import {snakeCase} from 'lodash';

export const MANAGE_INTERNAL_USERS = 'manageSuperAdmins';
export const MANAGE_COLLEGE_RANKS = 'manageCollegeRanks';
export const MANAGE_SFTP_USERS = 'manageSftpUsers';
export const FEATURE_FLAGS = [MANAGE_COLLEGE_RANKS, MANAGE_SFTP_USERS].map(snakeCase);
